import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import SelectAdvertiser from './SelectAdvertiser';
import WhichBestDescribesOfferCategory from './WhichBestDescribesOfferCategory';
import AdCampaignInfo from './AdCampaignInfo';
import WhereYouWantAdAppear from './WhereYouWantAdAppear';
import WhenShouldAdRun from './WhenShouldAdRun';
import UploadAd from './UploadAd';
import WebsiteConfirm from './WebsiteConfirm';
import CampaignBudget from './CampaignBudget';
import ReviewCampaign from './ReviewCampaign';
import PayForCampaign from './PayForCampaign';
import Congratulations from './Congratulations';
import { useProfile } from '../../../../Contexts/UserProfileContext';

const ConnectedDisplaAdContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const StyledProgressBar = styled.div`
    border: 1px solid black;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 600px;
    height: 25px;
    margin-bottom: 25px;
    border-radius: 25px;
`;
const StyledProgressBarInner = styled.div`
    background-color: green;
    width: 10%;
    height: 25px;
    border-radius: 25px;
`;

const ConnectedDisplaAd = (props) => {
    const {
        campaignData,
        setCampaignData,
        advertisers,
        setAdvertisers,
        saveNewCampaign,
        campaignPostData,
        setCampaignPostData,
        currentAdvertiser,
        setCurrentAdvertiser,
        pageIndex,
        setPageIndex,
        handleNavButtonBack,
        handleNavButtonNext,
    } = props;
    const { profile } = useProfile();

    const role = {
        isAgency: profile.isAgency,
        isAdvertiser: profile.isIndividual,
        isSiteAdmin: profile.isSiteAdmin,
    };

    const history = useHistory();

    useEffect(() => {
        if (currentAdvertiser === null) {
            setPageIndex(0);
        }
    }, [currentAdvertiser]);

    const shouldRenderSelectAdvertiser = () => {
        if (campaignData.campaignTypeName === '') {
            history.push('/portal/campaign/createACampaign');
        }

        if (role.isAgency || role.isSiteAdmin) {
            return (
                <SelectAdvertiser
                    handleNavButtonBack={handleNavButtonBack}
                    handleNavButtonNext={handleNavButtonNext}
                    campaignData={campaignData}
                    setCampaignData={setCampaignData}
                    advertisers={advertisers}
                    setAdvertisers={setAdvertisers}
                    currentAdvertiser={currentAdvertiser}
                    setCurrentAdvertiser={setCurrentAdvertiser}
                />
            );
        }

        if (role.isAdvertiser) {
            return setPageIndex(1);
        }
    };

    const ProgressBar = () => {
        const handleProgressPercent = () => {
            switch (pageIndex) {
                case 0:
                    return '10%';
                case 1:
                    return '20%';

                case 2:
                    return '30%';

                case 3:
                    return '40%';

                case 4:
                    return '50%';

                case 5:
                    return '60%';

                case 6:
                    return '70%';

                case 7:
                    return '90%';

                case 8:
                    return '90%';

                case 9:
                    return '100%';

                default:
                    return '100%';
            }
        };

        return (
            <div>
                {pageIndex < 10 ? (
                    <StyledProgressBar>
                        <StyledProgressBarInner style={{ width: handleProgressPercent() }}>
                            <div
                                style={{
                                    color: 'white',
                                    paddingTop: '2px',

                                    textAlign: 'center',
                                    fontSize: '14px',
                                    height: '100%',
                                }}
                            >
                                {handleProgressPercent()}
                            </div>
                        </StyledProgressBarInner>
                    </StyledProgressBar>
                ) : null}
            </div>
        );
    };

    const determinePage = () => {
        switch (pageIndex) {
            case 0:
                return shouldRenderSelectAdvertiser();
            case 1:
                return (
                    <WhichBestDescribesOfferCategory
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                    />
                );
            case 2:
                return (
                    <WebsiteConfirm
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        setPageIndex={setPageIndex}
                        currentAdvertiser={currentAdvertiser}
                        setCurrentAdvertiser={setCurrentAdvertiser}
                    />
                );
            case 3:
                return (
                    <WhereYouWantAdAppear
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                    />
                );
            case 4:
                return (
                    <WhenShouldAdRun
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        setPageIndex={setPageIndex}
                    />
                );
            case 5:
                return (
                    <UploadAd
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        setPageIndex={setPageIndex}
                    />
                );
            case 6:
                return (
                    <AdCampaignInfo
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        setPageIndex={setPageIndex}
                    />
                );
            case 7:
                return (
                    <CampaignBudget
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        setPageIndex={setPageIndex}
                    />
                );
            case 8:
                return (
                    <ReviewCampaign
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        currentAdvertiser={currentAdvertiser}
                    />
                );
            case 9:
                return (
                    <PayForCampaign
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        saveNewCampaign={saveNewCampaign}
                        campaignPostData={campaignPostData}
                        setCampaignPostData={setCampaignPostData}
                        advertisers={advertisers}
                        currentAdvertiser={currentAdvertiser}
                        setCurrentAdvertiser={setCurrentAdvertiser}
                    />
                );
            case 10:
                return (
                    <Congratulations
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        setPageIndex={setPageIndex}
                    />
                );
            default:
                return (
                    <SelectAdvertiser
                        handleNavButtonBack={handleNavButtonBack}
                        handleNavButtonNext={handleNavButtonNext}
                        campaignData={campaignData}
                        setCampaignData={setCampaignData}
                        currentAdvertiser={currentAdvertiser}
                        setCurrentAdvertiser={setCurrentAdvertiser}
                    />
                );
        }
    };

    return (
        <ConnectedDisplaAdContainer>
            {determinePage()}
            {ProgressBar()}
        </ConnectedDisplaAdContainer>
    );
};

ConnectedDisplaAd.propTypes = {
    campaignData: propTypes.shape({
        advertiserId: propTypes.oneOfType([propTypes.string, propTypes.number]),
        campaignTypeName: propTypes.string,
    }),
    setCampaignData: propTypes.func,
    advertisers: propTypes.shape({}),
    setAdvertisers: propTypes.func,
    saveNewCampaign: propTypes.func,
    campaignPostData: propTypes.shape({}),
    setCampaignPostData: propTypes.func,
    currentAdvertiser: propTypes.shape({}),
    setCurrentAdvertiser: propTypes.func,
    pageIndex: propTypes.number,
    setPageIndex: propTypes.func,
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
};

ConnectedDisplaAd.defaultProps = {
    campaignData: {},
    setCampaignData: () => {},
    advertisers: {},
    setAdvertisers: () => {},
    saveNewCampaign: () => {},
    campaignPostData: {},
    setCampaignPostData: () => {},
    pageIndex: 0,
    setPageIndex: () => {},
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
};
export default ConnectedDisplaAd;
